import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql, compose } from "react-apollo";
import {
  queryGetLabels,
  mutationAddLabelToAgent,
  mutationDeleteLabelFromAgent
} from "Apollo";
import { ShowNotice } from "Store";
import TreeLabelList from "module-common/label-list/TreeLabelList";

export default compose(
  graphql(queryGetLabels, {
    name: "labelsData"
  }),
  graphql(mutationAddLabelToAgent, { name: "mutateAdd" }),
  graphql(mutationDeleteLabelFromAgent, { name: "mutateDelete" })
)(
  class LabelListAgent extends Component {
    static propTypes = { id: PropTypes.number.isRequired };
    state = { treeLabels: [] };

    componentWillReceiveProps(nextProps) {
      const {
        labelsData: { caseLabels, customerLabels, streamLabels }
      } = nextProps;

      const allLabelMap = new Map();
      if (caseLabels) {
        for (const label of caseLabels) {
          allLabelMap.set(label.id, {
            label: label.displayName,
            isCollapsed: true,
            value: label,
            children: []
          });
        }
      }
      if (customerLabels) {
        for (const label of customerLabels) {
          allLabelMap.set(label.id, {
            label: label.displayName,
            isCollapsed: true,
            value: label,
            children: []
          });
        }
      }
      if (streamLabels) {
        for (const label of streamLabels) {
          allLabelMap.set(label.id, {
            label: label.displayName,
            isCollapsed: true,
            value: label,
            children: []
          });
        }
      }

      // build tree
      const treeLabels = [];
      for (const label of allLabelMap.values()) {
        // order in tree
        if (label.value.parentId === -1) {
          treeLabels.push(label);
        } else {
          const select = allLabelMap.get(label.value.parentId);
          if (select) {
            select.children.push(label);
          }
        }
      }
      this.setState({ treeLabels: treeLabels });
    }

    render() {
      const { ...rest } = this.props;
      const { treeLabels } = this.state;

      return (
        <TreeLabelList
          editable
          tree={treeLabels}
          onAdd={this.onAdd}
          onRemove={this.onRemove}
          onChange={treeLabels => this.setState(treeLabels)}
          {...rest}
        />
      );
    }

    onAdd = async label => {
      const { id, mutateAdd } = this.props;
      try {
        await mutateAdd({
          variables: {
            agent: { id: id },
            labels: [{ id: label.value.id }]
          },
          refetchQueries: ["getAgents"]
        });
        ShowNotice("label-add-success");
      } catch (error) {
        ShowNotice("label-add-error");
      }
    };

    onRemove = async label => {
      const { id, mutateDelete } = this.props;
      try {
        await mutateDelete({
          variables: {
            agent: { id: id },
            labels: [{ id: label.value.id }]
          },
          refetchQueries: ["getAgents"]
        });
        ShowNotice("label-delete-success");
      } catch (error) {
        ShowNotice("label-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/team-panel/TreeLabelListAgentWithQueryMutation.js